import React, { useState, useEffect, useMemo } from "react";
import EditItemCategoryModal from "../components/addItemEditModal";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import ItemMasterModal from "../components/itemMasterModal";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const AddNewSupplier = () => {
  useAuthRedirect();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [code, setCode] = useState(null);  
  const [itemName, setItemName] = useState(null);  
  const [part, setPart] = useState(null);  
const [freight, setFreight] = useState(""); 
const [sCode, setScode] = useState(""); 
const [uom, setUom] = useState([])
const [formData, setFormData] = useState({
    branch: "",
        code: "",
        name: "",
        user: "",
        address1: "",
        address2: "",
        pinCode: "",
        city: "",
        phone: "",
        email: "",
        fax: "",
        pan: "",
        tin: "",
        rcDate: "",
        gstNum: "",
        gstDate: "",
        taxType: "",
        tax: "",
        disc: "",
        pf: "",
        payment: "",
        delivery: "",
        insurance: "",
        ecc: "",
        remarks: "",
        subType: "",
})
const navigate = useNavigate();

/////////////////////////////////////////////////////////////
    const rawPerms = useMemo(() => localStorage.getItem("permissions") || localStorage.getItem("userPermissions"), []);
      const permsLoaded = !!rawPerms;
      
      //✅ Permission checks (safe even if perms not yet loaded; will be false)
      const canEntry = hasPermission("Supplier With Item", "entry");
      /////////////////////////////////////////////////////////////
    


useEffect(() => {
    const fetchScode = async () => {
      try {

        Swal.fire({
                title: "Fetching Supplier Code",
                html: `
                  <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                    <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                  </div>
                  <p style="margin-top: 10px; font-size: 14px;">Please wait while fetch Supplier Code...</p>
                `,
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                  const style = document.createElement("style");
                  style.innerHTML = `
                    @keyframes progressBar {
                      0% { width: 0% }
                      50% { width: 100% }
                      100% { width: 0% }
                    }
                  `;
                  document.head.appendChild(style);
                },
              });
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/supplierMaster_fetchCode`);

        if (response.data.newSCode) {
          const supplierCode = response.data.newSCode; // Keep it as a string (e.g., "S1")
          setScode(supplierCode);
          setFormData(prevState => ({ ...prevState, code: supplierCode }));
        }
        Swal.close();
      } catch (error) {
        Swal.close();
              console.error("Error fetching supplier code :", error);
              Swal.fire({
                icon: "error",
                title: "Oops!",
                text: "Error fetching supplier code. Please try again",
              });
        
      }
    };
{canEntry && (
    fetchScode()
)}
  }, []);

  





const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   if (!formData.name.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please enter Your name!',
        });
        return;
      }

        if (!formData.address1.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please enter Your Address!',
        });
        return;
      }

       if (!formData.city.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please enter Your City!',
        });
        return;
      }

       if (!formData.pinCode.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please enter Your Pincode!',
        });
        return;
      }

       if (!formData.phone.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please enter Your phone Number!',
        });
        return;
      }

       if (!formData.email.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please enter Your Email!',
        });
        return;
      }

      if (!formData.fax.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please enter Your Fax Number!',
        });
        return;
      }

      if (!formData.pan.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please enter PAN Number!',
        });
        return;
      }

       if (!formData.tin.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please enter TIN Number!',
        });
        return;
      }

        if (!formData.rcDate.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please Select RC Date!',
        });
        return;
      }

       if (!formData.gstNum.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please Enter GST No!',
        });
        return;
      }

       if (!formData.gstDate.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please Select GST Date!',
        });
        return;
      }

      if (!formData.taxType.trim()) {
  Swal.fire({
    icon: 'warning',
    title: 'Empty Field',
    text: 'Please Select Your Tax Type!',
  });
  return;
}

// Only check tax percentage if GST is selected
if (formData.taxType.trim() === "GST") {
  if (!formData.tax.trim()) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Enter Your Tax Percentage!",
    });
    return;
  }

  const taxValue = Number(formData.tax);

  if (isNaN(taxValue) || taxValue < 0 || taxValue > 100) {
    Swal.fire({
      icon: "warning",
      title: "Invalid Tax",
      text: "Tax Percentage must be a number between 0 and 100.",
    });
    return;
  }
}


       // ==== Discount Validation ====
if (!formData.disc.trim()) {
  Swal.fire({
    icon: "warning",
    title: "Empty Field",
    text: "Enter Your Discount Percentage!",
  });
  return;
}

const discValue = Number(formData.disc);
if (isNaN(discValue) || discValue < 0 || discValue > 100) {
  Swal.fire({
    icon: "warning",
    title: "Invalid Discount",
    text: "Discount Percentage must be a number between 0 and 100.",
  });
  return;
}

// ==== PF Validation ====
if (!formData.pf.trim()) {
  Swal.fire({
    icon: "warning",
    title: "Empty Field",
    text: "Enter Your PF Percentage!",
  });
  return;
}

const pfValue = Number(formData.pf);
if (isNaN(pfValue) || pfValue < 0 || pfValue > 100) {
  Swal.fire({
    icon: "warning",
    title: "Invalid PF",
    text: "PF Percentage must be a number between 0 and 100.",
  });
  return;
}


        if (!formData.ecc) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Enter Your ECC Number!',
        });
        return;
      }

        if (!formData.supplierType.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Select YOur Supplier Type!',
        });
        return;
      }



    const payload = {
        branch: branch,
        code: formData.code,
        name: formData.name,
        user: user,
        address1: formData.address1,
        address2: formData.address2,
        pinCode: formData.pinCode,
        city: formData.city,
        phone: formData.phone,
        email: formData.email,
        fax: formData.fax,
        pan: formData.pan,
        tin: formData.tin,
        rcDate: formData.rcDate,
        gstNum: formData.gstNum,
        gstDate: formData.gstDate,
        taxType: formData.taxType,
        tax: formData.tax,
        disc: formData.disc,
        pf: formData.pf,
        payment: formData.payment,
        delivery: formData.delivery,
        insurance: formData.insurance,
        ecc: formData.ecc,
        remarks: formData.remarks,
        subType: formData.supplierType,
    };

    console.log(payload);

    try {
         Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

        const response = await axios.post("https://rfs2.infraconsoft.net.in/api/supplierMaster_insert", payload);
        Swal.fire("Success", "Supplier added successfully", "success");
        // alert("Success");
        navigate('/inventory/supplierMasterView');
    } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
};

if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
            <div className="back-div">
          <h2 className="add-txt">Supplier Master - Add</h2>
          <Link to='/inventory/supplierMasterView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
          <div className="form-group">
                <label>Name :</label>
                <input type="text" name="name" value={formData.name} onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="code" value={formData.code} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1" value={formData.address1} onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>address 2 :</label>
                <input type="text" name="address2" value={formData.address2} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city" value={formData.city} onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>PinCode :</label>
                <input type="text" name="pinCode" value={formData.pinCode} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Phone Number :</label>
                <input type="text" name="phone" value={formData.phone} onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Email :</label>
                <input type="text" name="email" value={formData.email} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Fax :</label>
                <input type="text" name="fax" value={formData.fax} onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>PAN Number :</label>
                <input type="text" name="pan" value={formData.pan} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>TIN Number :</label>
                <input type="text" name="tin" value={formData.tin} onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>RC Date :</label>
                <input type="date" name="rcDate" value={formData.rcDate} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>GST Number :</label>
                <input type="text" name="gstNum" value={formData.gstNum} onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>GST Date :</label>
                <input type="date" name="gstDate" value={formData.gstDate} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
              <label>Tax Type :</label>
                <select name="taxType" value={formData.taxType} onChange={handleChange}>
                  <option value="">-- Select --</option>
                  <option value="GST">GST</option>
                  <option value="NO TAX">NO TAX</option>
                </select>
              </div>
              <div className="form-group">
                <label>Tax Per% :</label>
                <input type="number" name="tax" value={formData.tax} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Discount % :</label>
                <input type="number" name="disc" value={formData.disc} onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>P&F % :</label>
                <input type="number" name="pf" value={formData.pf} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Payment :</label>
                <select name="payment" value={formData.payment} onChange={handleChange}>
                  <option value="">-- Select --</option>
                  <option value="Immediate">Immediate</option>
                  <option value="30 Days">30 Days</option>
                  <option value="60 Days">60 Days</option>
                  <option value="Against Perform">Against Perform</option>
                  <option value="After Installation">After Installation</option>
                  <option value="Through Bank">Through Bank</option>
                </select>
              </div>
              <div className="form-group">
                <label>Delivery :</label>
                <select name="delivery" value={formData.delivery} onChange={handleChange}>
                  <option value="">-- Select --</option>
                  <option value="Door">Door</option>
                  <option value="Collect By Us">Collect By Us</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Insurance :</label>
                <select name="insurance" value={formData.insurance} onChange={handleChange}>
                  <option value="">-- Select --</option>
                  <option value="Not Applicable">Not Applicable</option>
                  <option value="Our A/c">Our A/c</option>
                  <option value="Your A/c">Your A/c</option>
                </select>
              </div>
              <div className="form-group">
              <label>ECC Number :</label>
              <input type="text" name="ecc" value={formData.ecc} onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
              <label>Remarks :</label>
              <input type="text" name="remarks" value={formData.remarks} onChange={handleChange}/>
              </div>
              <div className="form-group">
              <label>Supplier Type :</label>
                <select name="supplierType" value={formData.supplierType} onChange={handleChange}>
                  <option value="">-- Select --</option>
                  <option value="Vendor-Approved">Vendor-Approved</option>
                  <option value="Vendor-Non-Approved">Vendor-Non-Approved</option>
                </select>
              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default AddNewSupplier;
